import styled, { css } from "styled-components";

import { breakpoints, sectionRhythm } from "../../../theme";
import { PageSection } from "../../components/layout/layout-styles";
import { Heading as HeadingStyles } from "../../components/common/Typography/type-styles";
import Button from "../../components/form/Button";

export const LIST_GAP = "12px";
export const GRID_GAP = "32px";

export const Section = styled(PageSection)`
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#ffffff")};
`;

export const Heading = styled(HeadingStyles).attrs({ as: "h2" })``;

export const BlogPostsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${LIST_GAP};
  width: 94%;
  margin: ${sectionRhythm.paddingY.mobile}px auto 0;

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    margin: ${sectionRhythm.paddingY.desktop}px auto 0;
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${GRID_GAP};
    width: 85%;

    ${(props) =>
      props.variant === "wide" &&
      css`
        grid-template-columns: 1fr;
        width: 75%;
      `}
  }
  @media only screen and (min-width: 1260px) {
    grid-template-columns: repeat(3, 1fr);
    width: 90%;

    ${(props) =>
      props.variant === "wide" &&
      css`
        grid-template-columns: 1fr;
        width: 75%;
      `}
  }
  @media only screen and (min-width: 2000px) {
    grid-template-columns: repeat(4, 1fr);
    width: 90%;

    ${(props) =>
      props.variant === "wide" &&
      css`
        grid-template-columns: 1fr;
        width: 75%;
      `}
  }

  ${(props) =>
    props.isEmpty &&
    css`
      grid-template-columns: 1fr !important;
    `}
`;

export const BlogListStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) =>
    props.$hasViewAll ? `${sectionRhythm.paddingY.mobile / 2}px` : 0};

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    gap: ${(props) =>
      props.$hasViewAll ? `${sectionRhythm.paddingY.desktop / 2}px` : 0};
  }
`;

export const StyledButton = styled(Button)`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 24px;
    padding: 21px 39px;
  }
`;

export const ComingSoonText = styled.span`
  text-align: center;
  display: block;
  width: 100%;
  font-size: 14px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 20px;
  }
`;
